<template>
  <div class="kitchenCover">
    <Locale />
    <div class="relative-position">
      <q-img
        basic
        :placeholder-src="$ossLimit(defaultCover, 256)"
        :src="$ossLimit(storeInfo.cover || defaultCover, coverWidth)"
        :ratio="9 / 7"
      />
      <Card :info="info" @showMap="handleShowMap">
        <Nearest
          v-if="info.chainStore"
          slot="nearest"
          ref="nearest"
          :position="position"
        />
      </Card>
      <HowToOrder />
      <VoucherModule class="voucher" />
      <Button :info="info" :status="info.status" @showNearest="showNearest" />
      <Type
        v-if="scheduled && scheduled.scheduledEnable"
        :icons="icons"
        :info="info"
        @showNearest="showNearest"
      >
        <img
          slot="btn"
          class="type-btn-img"
          src="https://static.bakmigm.co.id/menu/ykitchen-6329a03b14327c63d9d5ee372b54ef661.png"
        />
      </Type>
    </div>
    <MapComponent v-model="showMap" :position="position" />
    <Bottom
      icons="https://static.bakmigm.co.id/menu/ykitchen-55296cbb379b4b5255fd3e663c583042.png"
      :status="info.status"
    />
  </div>
</template>

<script setup>
import { ref, computed, defineProps, watch, provide } from 'vue';
import { defaultCover } from 'src/utils/config';
import { pushLog } from 'src/utils/pushLog';
import { useRoute } from 'src/utils/v2_helper/router';
import { useStore } from '../../../../utils/v2_helper/common';
import {
  Locale,
  Card,
  Map as MapComponent,
  Type,
  Nearest,
  Bottom,
} from '../../components/index';
import Button from './Button.vue';
import VoucherModule from '../../components/voucher/index.vue';
import HowToOrder from '../../components/HowToOrder.vue';

const store = useStore();
const route = useRoute();
const props = defineProps({
  info: {
    type: Object,
    default: () => {},
  },
});
const nearestRef = ref();
const showMap = ref(false);
const scheduled = computed(() => store.state.prefetch.storeInfo.scheduled);
const position = computed(() => {
  const { latitude, longitude } = props.info?.storeLocation || {
    latitude: 0,
    longitude: 0,
  };
  return { lat: latitude, lng: longitude };
});

const coverWidth = computed(() => {
  const width = (process.env.SERVER ? 0 : document.body.clientWidth) + 300;
  // eslint-disable-next-line no-nested-ternary
  return width < 400 ? 400 : width > 700 ? 700 : width;
});

function showNearest() {
  nearestRef.value.handleShowNearest('DELIVERY');
}
function handleShowMap() {
  pushLog({
    key: 'kitchen_address_map_inited',
    type: 'googlemap',
    url: route.fullPath,
    env: process.env.NODE_ENV,
  });
  showMap.value = true;
}

provide('position', position);
</script>

<style lang="scss" scoped>
.kitchenCover {
  background: url('https://static.bakmigm.co.id/menu/ykitchen-e10adc3949b1485bbe56e057f20f883e.png')
    right bottom no-repeat #ec1e24;
  background-size: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
  .type-btn-img {
    height: 26px;
  }
  :deep(.infoCard) {
    .cardBox {
      background: url('https://static.bakmigm.co.id/menu/ykitchen-2f2b128b50213200106ac43869dd9c65.png')
        0 0 no-repeat #e6e7e8 !important;
      background-size: 100% !important;
      .expansionBox {
        display: inline-block;
        padding-right: 0;
        background: #e6e7e8;
        .q-card {
          background: #e6e7e8;
        }
      }
    }
    .logoImg {
      border-color: #000;
    }
  }
  :deep(.bottom) {
    background: #ec1e24;
    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.15);
    .top {
      color: #fff;
    }
  }
  :deep(.chooseType .schedule) {
    .q-btn {
      border: 2px solid #000;
      background: #e6e7e8;
    }
    .text {
      color: #fff;
    }
  }
  :deep(.funButton) {
    .q-btn {
      border: 2px solid #000;
      background: #e6e7e8;
    }
  }
  :deep(.voucher) {
    .hpromo-btn {
      outline: 2px solid #000;
      background: #e6e7e8;
    }
    .hpromo-btn-icon {
      background-image: url(https://static.bakmigm.co.id/menu/home_promo_icon_22_12_13.png);
    }
  }
}
</style>
